import { useQuery } from '@apollo/client';

import {
  CreditCardTotalsDocument,
  CreditCardTotalsQueryVariables,
} from './creditCardTotals.gql';

const useUserCreditCardTotalsQuery = ({
  creditCardId,
  skip,
}: CreditCardTotalsQueryVariables & { skip?: boolean }) => {
  const { data, ...hook } = useQuery(CreditCardTotalsDocument, {
    skip: !creditCardId || skip,
    variables: { creditCardId },
  });

  return { ...hook };
};

export default useUserCreditCardTotalsQuery;
